import React from "react"
import TextField from "@mui/material/TextField"

import { useUnsavedChangesWarning } from "lib/core/react.utils"

// Apply default props and styles to on material-ui TextField component.
const MLUTextField = ({
  shouldAbortLeave = false,
  formName = "",
  isDirty = false,
  shouldSaveContent = false,
  variant = "standard",
  value,
  ...props
}) => {
  const textFieldStyles = (theme) => ({
    backgroundColor: "#f3f3f4",
    "& .MuiInputBase-multiline": {
      padding: "5px",
    },

    "& .MuiInputBase-root": {
      "& .MuiInputBase-input": {
        color: theme.palette.text.primary,
        fontSize: theme.typography.fontSize,
        lineHeight: 1.5,
        padding: "5px",

        "&::placeholder": {
          fontStyle: "italic",
          color: theme.palette.text.primary,
          opacity: 1,
        },
      },
    },
  })

  useUnsavedChangesWarning({
    content: value,
    formName,
    isDirty,
    shouldAbortLeave,
    shouldSaveContent,
  })

  return (
    <TextField
      value={value}
      {...props}
      variant={variant}
      InputProps={{
        disableUnderline: true,
        ...(props.InputProps || {}),
      }}
      sx={textFieldStyles}
    />
  )
}

export default MLUTextField
